// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"4464":"d86454c5","7846":"a31b6139"}[chunkId] + ".css";
};